import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import ProductConstants, { productDimensions } from '../../common/ProductConstants';
import * as styles from './ProductOptionPills.css';

const cx = classNames.bind(styles);

function ProductOptionPills({
    productOptions,
    onOptionClick,
    selectedOption,
    clientRendering = false,
    customOptions,
    checkSizeWarning,
    extendedSizeDetails = [],
}) {
    const getTruncateValue = (option = '') => {
        const optionLength = option.length;
        if (optionLength >= 24) {
            let value = '';
            for (let i = 0; i < optionLength; i += 1) {
                value += option[i];
                if (i >= 24) {
                    value = `${customOptions ? name : value}...`;
                    break;
                }
            }
            return value.toLowerCase();
        }
        return option.toLowerCase();
    };

    const onPillsClick = (value, url) => {
        if (url) {
            window && window.location.assign(url);
        } else if (onOptionClick) {
            onOptionClick(productOptions, null, value);
        }
    };
    const isExtendedSizeEligible =
        productOptions.id === productDimensions.SIZE_RANGE && extendedSizeDetails?.length > 0;
    if (isExtendedSizeEligible) {
        extendedSizeDetails?.map((data) => {
            productOptions.options.push({
                value: data.linkText,
                id: ProductConstants.EXTENDEDSIZERANGE,
                url: data.link,
            });
        });
    }
    return (
        <>
            <section className={cx('pillsContainer')} data-automation-id="productOptionPillsBlock">
                <ul className={cx('pills')}>
                    {productOptions.options &&
                        productOptions.options.map(
                            ({ name, value, availableInStock, availabilityMessage, url }) => {
                                const isOptionSelected = customOptions
                                    ? name && name.toLowerCase() === selectedOption.toLowerCase()
                                    : value && value.toLowerCase() === selectedOption.toLowerCase();
                                const isOOS = availableInStock === false;
                                return (
                                    <li
                                        key={`${value}-${clientRendering ? 'c' : 's'}-${
                                            availabilityMessage ? 'a' : ''
                                        }`}
                                        className={cx('pillsBlock')}
                                        data-option={customOptions ? name : value}
                                    >
                                        <button
                                            onClick={() => onPillsClick(value, url)}
                                            className={cx({
                                                btn: true,
                                                btnDefault: true,
                                                btnNunSelected: checkSizeWarning && !isOOS,
                                                btnOos: isOOS,
                                                btnSelected: isOptionSelected,
                                                btnOosSelected: isOOS && isOptionSelected,
                                            })}
                                        >
                                            {getTruncateValue(customOptions ? name : value)}
                                        </button>
                                    </li>
                                );
                            }
                        )}
                </ul>
            </section>
        </>
    );
}

ProductOptionPills.propTypes = {
    productOptions: PropTypes.object,
    selectedOption: PropTypes.string,
    onOptionClick: PropTypes.func,
    clientRendering: PropTypes.bool,
    customOptions: PropTypes.bool,
    checkSizeWarning: PropTypes.bool,
};

ProductOptionPills.defaultProps = {
    productOptions: {},
    selectedOption: '',
    onOptionClick: null,
    clientRendering: false,
    customOptions: false,
    checkSizeWarning: false,
};

export default ProductOptionPills;
